"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealKasherCircleFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealKasherCircleFilled = function MealKasherCircleFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#MealKasherCircleFilled_svg__MealKasherCircleFilled_svg__clip0_886_4910)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20z",
    fill: "#C4D600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.625 9.97L20 4.243l3.374 5.727h-6.748zm-1.74 0l4.037-6.854a1.25 1.25 0 012.154 0l4.038 6.854h9.633a1.25 1.25 0 011.077 1.885l-4.8 8.148 4.8 8.146a1.25 1.25 0 01-1.078 1.885h-9.63l-4.039 6.854a1.25 1.25 0 01-2.154 0l-4.038-6.854H5.252a1.25 1.25 0 01-1.077-1.885l4.8-8.148-4.8-8.146A1.25 1.25 0 015.254 9.97h9.631zm-5.04 8.553L5.69 11.47H14l-4.155 7.053zm.87 1.478l5.026-8.53h8.516l5.026 8.532-5.025 8.53h-8.516l-5.026-8.532zm-.87 1.478L5.69 28.534h8.312l-4.156-7.055zm6.78 8.555L20 35.76l3.374-5.727h-6.748zm9.374-1.5h8.31l-4.155-7.054-4.155 7.054zm4.155-10.01l4.156-7.054h-8.312l4.156 7.055z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "MealKasherCircleFilled_svg__MealKasherCircleFilled_svg__clip0_886_4910"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};

exports.MealKasherCircleFilled = MealKasherCircleFilled;
var _default = MealKasherCircleFilled;
exports.default = _default;